<template>
  <div>
    <template v-if="contactTypeBoxes.length">
      <form-field-checkbox
        v-for="type in contactTypeBoxes"
        :key="type.id"
        :native-value="type.include"
        v-model="type.include"
        :label="type.label"
      ></form-field-checkbox>

      <hr class="mb-50">
      <p class="contact_type_link">Edit contact types on the
        <router-link :to="{name: 'settings', params: {tab: 'contacts'}}">contact setting page</router-link>
      </p>
    </template>
    <p v-else class="contact_type_empty">You have no contact types set up, you can set some up on the
      <router-link :to="{name: 'settings', params: {tab: 'contacts'}}">Contact Setting Page</router-link>
    </p>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "ContactContactTypeForm",
  props: ["formData"],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        id: "",
      },
    };
  },
  created() {
    // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
    this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
  },
  computed: {
    activeContact() {
      return this.$store.state.activeContact;
    },
    availableContactTypes() {
      return this.$store.getters.contactTypes;
    },
    contactTypeBoxes() {
      let boxes = [];

      this.availableContactTypes.forEach(type => {
        let include = false;

        if (this.activeContact.contactContactTypes.find(contactType => contactType.contact_type_id === type.id)) {
          include = true;
        }

        boxes.push({
          id: type.id,
          label: type.name,
          include: include
        });
      });

      return boxes;
    }
  },
  methods: {
    update() {
      let contactTypeIds = [];

      this.contactTypeBoxes.forEach(type => {
        if (type.include) {
          contactTypeIds.push(type.id);
        }
      });

      this.form.contact_type_ids = contactTypeIds;

      return this.$api.contacts.attachContactTypes(this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: "Contact Types were updated",
            type: "is-success"
          });

          return res;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables/variables";

.contact_type_link {
  color: $text-light;
  font-size: 0.8rem;
  text-align: center;
}

.contact_type_empty {
  padding: 1rem 0 1.5rem;
  font-style: italic;
  line-height: 1.3;
}
</style>
